import * as React from 'react'
interface Props {
    apiProviderId: number | undefined
}

const AdminExternalCitiesMappings = (props: Props) => {
    return <h2>Cities Mappings</h2>
}
export default AdminExternalCitiesMappings